'use strict';

import Search from 'js/models/search';
import formatModel from 'js/lib/formatModel';
import { processAccordingNotificationType } from 'js/utils/processAccordingNotificationType';
import config from 'js/config';

function defaultExtractor(notification) {
  const postAttributes = notification.post ? {
    groupId: notification.post.groupId,
    link: getPostLink(notification),
  } : {};

  return {
    ...postAttributes,
    date: notification.date,
    userId: notification.userId,
    activityType: notification.type,
  };
}

const extractors = {
  like: function like(notification) {
    return {
      actionVerb: i18n('liked your post'),
      title: notification.post.snippet,
    };
  },
  followUser: function followUser() {
    return {
      actionVerb: i18n('is now following you!'),
    };
  },
  followPost: function followPost(notification) {
    return {
      actionVerb: i18n('saved your post'),
      title: notification.post.title,
    };
  },
  mention: function mention(notification) {
    return {
      actionVerb: i18n('has mentioned you in'),
      title: notification.post.title ? `${notification.post.title}` : ' their reply',
      userId: notification.post.authorId,
    };
  },
  mentionReply: function mention(notification) {
    return {
      actionVerb: i18n('has mentioned you in'),
      title: notification.post.superParent.title ? `${notification.post.superParent.title}` : ' their reply',
      snippet: notification.post.snippet,
      userId: notification.post.authorId,
    };
  },
  reply: function reply(notification) {
    return {
      actionVerb: i18n('responded to'),
      snippet: notification.post.snippet,
      title: notification.post.superParent.title,
      userId: notification.post.authorId,
    };
  },
  blog: function blog(notification) {
    const post = notification.post;
    const snippet = post.snippet.length > config.text.brief.length
      ? `${post.snippet.slice(0, config.text.brief.length)}...`
      : post.snippet;

    return {
      actionVerb: i18n('wrote'),
      snippet,
      title: post.title,
      totalResponses: post.totalResponses,
    };
  },
  answer: function answer(notification) {
    const title = notification.post.title
      || (notification.post.superParent && notification.post.superParent.title);

    return {
      actionVerb: i18n('answered in'),
      snippet: notification.post.snippet,
      title,
    };
  },
  poll: function blog(notification) {
    return {
      actionVerb: i18n('set a poll'),
      title: notification.post.title,
      link: getPostLink(notification, 'polls'),
    };
  },
  likeReply: function likeReply(notification) {
    return {
      actionVerb: i18n('liked your reply'),
      title: notification.post.snippet,
    };
  },
  customNotification: function customNotification(notification) {
    return {
      userId: null,
      text: notification.text,
      link: notification.link,
    };
  },
};

const getPostLink = function(notification, type = 'posts') {
  const post = notification.post.superParent || notification.post;

  const postId = post.id;
  const title = post.urlEncodedTitle;
  const responseId = notification.post.superParent ? notification.post.id : undefined;

  const responses = responseId !== undefined ? `?responses=${responseId}` : '';
  if(notification.post.superParent && notification.post.superParent.postTypeId === 6 && title !== '') {
    return `polls/${postId}/${title}${responses}/result`;
  } else {
    return `${type}/${postId}/${title}${responses}`;
  }
};

var Activity = Search.extend();

/**
 * Parse api endpoint data
 */
Activity.prototype.parse = function(attributes) {
  const extract = processAccordingNotificationType(attributes, extractors) || extractors.blog;
  const data = Object.assign(defaultExtractor(attributes), extract(attributes));

  const user = data.userId ? this.getCachedData('users', data.userId) : null;
  const group = data.groupId ? this.getCachedData('groups', data.groupId) : null;
  const link = data.link && group
    ? `/${group.get('subDomain')}/${data.link}`
    : user ? `/user/${user.get('username').toLowerCase()}` : data.link;

  const model = {
    ...data,
    link,
    user,
  };

  const userModels = this.getCachedData('users', {}, true) || [];
  const users = userModels.map(model => model.attributes);

  return formatModel({ model, users });
};

module.exports = Activity;



// WEBPACK FOOTER //
// ./app/assets/js/models/activity.js